module.exports = __webpack_public_path__ + "static/media/0019.d5b59528.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48103/RAL/0019.png
// module id = 1588
// module chunks = 0